// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3pr9a","title":"BackImages_title__OY25H","images":"BackImages_images__293RG"};